/**
 * @license
 * Copyright (c) 2025 Handsoncode. All rights reserved.
 */
export class InterpreterState {
  constructor(formulaAddress, arraysFlag, formulaVertex) {
    this.formulaAddress = formulaAddress;
    this.arraysFlag = arraysFlag;
    this.formulaVertex = formulaVertex;
  }
}